export default __webpack_public_path__ + "static/media/issues-close.ab56858a.svg";